// extracted by mini-css-extract-plugin
module.exports = {"dialog_wrapper":"modal_dialog_wrapper__1LDxA","title_wrapper":"modal_title_wrapper__2Pjw9","border_bottom":"modal_border_bottom__bBK7B","address":"modal_address__ALIuS"};